import Vue from 'vue'
import Router from 'vue-router'

// import HelloWorld from '@/components/HelloWorld'
const Activity = ()=> import('@/views/Activity')
const Assistant = ()=> import('@/views/Assistant')
const AccountNumber = ()=> import('@/views/AccountNumber')
const Audit = ()=> import('@/views/Audit')
const ArticleDetail = ()=> import('@/views/ArticleDetail')
const ArtivityList = ()=> import('@/views/ArtivityList')
const Agreement = ()=> import('@/views/Agreement')
const Agreement2 = ()=> import('@/views/Agreement2')
const Agreement3 = ()=> import('@/views/Agreement3')
const BookAdd = ()=> import('@/views/BookAdd')
const BagSignup = ()=> import('@/views/BagSignup')
const BagReservation = ()=> import('@/views/BagReservation')
const BorrowedBooks = ()=> import('@/views/BorrowedBooks')
const BorrowedReservation = ()=> import('@/views/BorrowedReservation')
const CommentList = ()=> import('@/views/CommentList')
const ChangePassword = ()=> import('@/views/ChangePassword')
const ChangeEmail = ()=> import('@/views/ChangeEmail')
const ChangeEmail2 = ()=> import('@/views/ChangeEmail2')
const ChangeEmailOk = ()=> import('@/views/ChangeEmailOk')
const Jihuo = ()=> import('@/views/Jihuo')

const ChangePhone = ()=> import('@/views/ChangePhone')
const ChangePhone2 = ()=> import('@/views/ChangePhone2')
const CheckCode = ()=> import('@/views/CheckCode')
const EventDetails = ()=> import('@/views/EventDetails')
const HelpDetail = ()=> import('@/views/HelpDetail')
const HelpCenter = ()=> import('@/views/HelpCenter')
const Home = ()=> import('@/views/Home')
const HistoryLectures = ()=> import('@/views/HistoryLectures')
const JieyueLishi = ()=> import('@/views/JieyueLishi')
const IpadBook = ()=> import('@/views/IpadBook')
const IpadDetail = ()=> import('@/views/IpadDetail')
const InLibrary = ()=> import('@/views/InLibrary')
const IsFine = ()=> import('@/views/IsFine')
const Locker = ()=> import('@/views/Locker')
const Login = ()=> import('@/views/Login')
const LibraryQuery = ()=> import('@/views/LibraryQuery')
const LibraryDetail = ()=> import('@/views/LibraryDetail')
const LectureReview = ()=> import('@/views/LectureReview')
const ResourceCenter = ()=> import('@/views/ResourceCenter')
const Reservation = ()=> import('@/views/Reservation')
const ReadBooking = ()=> import('@/views/ReadBooking')
const Recommendation = ()=> import('@/views/Recommendation')
const RecommendationDetail = ()=> import('@/views/RecommendationDetail')
const RecommendationRead = ()=> import('@/views/RecommendationRead')
const RecommendationGuize = ()=> import('@/views/RecommendationGuize')

const ReadingCode = ()=> import('@/views/ReadingCode')
const ReadingSure = ()=> import('@/views/ReadingSure')
const SeminarReservation = ()=> import('@/views/SeminarReservation')
const SeminarRoom = ()=> import('@/views/SeminarRoom')
const Search = ()=> import('@/views/Search')
const SignUp = ()=> import('@/views/SignUp')
const ScanResult = ()=> import('@/views/ScanResult')
const Message = ()=> import('@/views/Message')
const MessageDetail = ()=> import('@/views/MessageDetail')
const MySet = ()=> import('@/views/MySet')
const MyFine = ()=> import('@/views/MyFine')
const Myjiangou = ()=> import('@/views/Myjiangou')
const MyComment = ()=> import('@/views/MyComment')
const MyLecture = ()=> import('@/views/MyLecture')
const MicroReading = ()=> import('@/views/MicroReading')
const UseRules = ()=> import('@/views/UseRules')
const UseInstructions = ()=> import('@/views/UseInstructions')
const JianSuo = ()=> import('@/views/JianSuo')
const MyReport = ()=> import('@/views/MyReport')

Vue.use(Router)

export default new Router({
  mode:'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/activity',
      name: 'Activity',
      component: Activity
    },
    {
      path: '/myLecture',
      name: 'MyLecture',
      component: MyLecture
    },
    {
      path: '/jieyueLishi',
      name: 'JieyueLishi',
      component: JieyueLishi 
    },
    {
      path: '/historyLectures',
      name: 'HistoryLectures',
      component: HistoryLectures
    },
   
    {
      path: '/seminarRoom',
      name: 'SeminarRoom',
      component: SeminarRoom
    },
    {
      path: '/microReading',
      name: 'MicroReading',
      component: MicroReading
    },
    {
      path: '/myFine',
      name: 'MyFine',
      component: MyFine
    },
    {
      path: '/borrowedBooks',
      name: 'BorrowedBooks',
      component: BorrowedBooks
    },
    {
      path: '/checkCode',
      name: 'CheckCode',
      component: CheckCode
    },
    {
      path: '/locker',
      name: 'Locker',
      component: Locker
    },
    {
      path: '/assistant',
      name: 'Assistant',
      component: Assistant
    },
    {
      path: '/bookAdd',
      name: 'BookAdd',
      component: BookAdd
    },
    {
      path: '/readBooking',
      name: 'ReadBooking',
      component: ReadBooking
    },
    {
      path: '/accountNumber',
      name: 'AccountNumber',
      component: AccountNumber
    },
    {
      path: '/audit',
      name: 'Audit',
      component: Audit
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/search',
      name: 'Search',
      component: Search,
    },
    {
      path: '/libraryQuery',
      name: 'LibraryQuery',
      component: LibraryQuery
    },
    {
      path: '/message',
      name: 'Message',
      component: Message
    },
    {
      path: '/mySet',
      name: 'MySet',
      component: MySet
    },
    {
      path: '/changepassword',
      name: 'ChangePassword',
      component: ChangePassword
    },
   
    {
      path: '/changeemail',
      name: 'ChangeEmail',
      component: ChangeEmail
    },
    {
      path: '/changeemail2',
      name: 'ChangeEmail2',
      component: ChangeEmail2
    },
    {
      path: '/changeemailok',
      name: 'ChangeEmailOk',
      component: ChangeEmailOk
    },
    {
      path: '/jihuo',
      name: 'Jihuo',
      component: Jihuo
    },
    {
      path: '/changephone',
      name: 'ChangePhone',
      component: ChangePhone
    },
     {
      path: '/changephone2',
      name: 'ChangePhone2',
      component: ChangePhone2
    },
    {
      path: '/commentList',
      name: 'CommentList',
      component: CommentList
    },
    {
      path: '/helpcenter',
      name: 'HelpCenter',
      component: HelpCenter
    },
    {
      path: '/seminarreservation',
      name: 'SeminarReservation',
      component: SeminarReservation
    },
    {
      path: '/reservation',
      name: 'Reservation',
      component: Reservation
    },
    {
      path: '/eventDetails',
      name: 'EventDetails',
      component: EventDetails
    },
    {
      path: '/ipadBook',
      name: 'IpadBook',
      component: IpadBook
    },
    {
      path: '/libraryDetail',
      name: 'LibraryDetail',
      component: LibraryDetail
    },
    {
      path: '/signUp',
      name: 'SignUp',
      component: SignUp
    },
    {
      path: '/helpDetail',
      name: 'HelpDetail',
      component: HelpDetail
    },
    {
      path: '/lectureReview',
      name: 'LectureReview',
      component: LectureReview
    },
    {
      path: '/bagSignup',
      name: 'BagSignup',
      component: BagSignup
    },
    {
      path: '/resourceCenter',
      name: 'ResourceCenter',
      component: ResourceCenter
    },
    {
      path: '/ipadDetail',
      name: 'IpadDetail',
      component: IpadDetail
    },
    {
      path: '/inLibrary',
      name: 'InLibrary',
      component: InLibrary
    },
    {
      path: '/recommendation',
      name: 'Recommendation',
      component: Recommendation
    },
    {
      path: '/recommendationDetail',
      name: 'RecommendationDetail',
      component: RecommendationDetail
    },
    {
      path: '/recommendationRead',
      name: 'RecommendationRead',
      component: RecommendationRead
    },
    {
      path: '/recommendationGuize',
      name: 'RecommendationGuize',
      component: RecommendationGuize
    },
    {
      path: '/readingCode',
      name: 'ReadingCode',
      component: ReadingCode 
    },
    {
      path: '/readingSure',
      name: 'ReadingSure',
      component: ReadingSure,
      mate:{
        login_request:true
      }
    },
    {
      path: '/useRules',
      name: 'UseRules',
      component: UseRules
    },
    {
      path: '/useInstructions',
      name: 'UseInstructions',
      component: UseInstructions
    },
    {
      path: '/articleDetail',
      name: 'ArticleDetail',
      component: ArticleDetail
    },
    {
      path: '/messageDetail',
      name: 'MessageDetail',
      component: MessageDetail
    },
    {
      path: '/myComment',
      name: 'MyComment',
      component: MyComment
    },
    {
      path: '/isFine',
      name: 'isFine',
      component: IsFine
    },
    {
      path: '/jiansuo',
      name: 'JianSuo',
      component: JianSuo
    },
    {
      path: '/borrowedReservation',
      name: 'BorrowedReservation',
      component:BorrowedReservation
    },
    {
      path: '/artivityList',
      name: 'ArtivityList',
      component: ArtivityList
    },
    {
      path: '/myjiangou',
      name: 'myjiangou',
      component: Myjiangou
    },
    {
      path: '/bagReservation',
      name: 'bagReservation',
      component: BagReservation
    },
    {
      path: '/agreement',
      name: 'Agreement',
      component: Agreement
    },
    {
      path: '/agreement2',
      name: 'Agreement2',
      component: Agreement2
    },
    {
      path: '/agreement3',
      name: 'Agreement3',
      component: Agreement3
    },
    {
      path: '/scanResult',
      name: 'ScanResult',
      component: ScanResult
    },
    {
      path: '/myReport',
      name: 'MyReport',
      component: MyReport
    },
    
    // {
    //   path: '/helloWorld',
    //   name: 'HelloWorld',
    //   component: HelloWorld
    // },

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js